document.addEventListener('DOMContentLoaded', function () {
  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Change the style of the element to make it visible
        entry.target.style.opacity = 1;

        // Your existing animation code
        var svgs = entry.target.querySelectorAll('.progress-svg');

        svgs.forEach(function (svg) {
          var circle = svg.querySelector('.progress');
          var text = svg.querySelector('.percent-text');
          var targetPercent =
            parseFloat(svg.getAttribute('data-percent')) * 4.7;
          var angle = 0;
          var timer = setInterval(function () {
            circle.setAttribute('stroke-dasharray', angle + ', 20000');
            // text.innerHTML = parseInt(angle / 472 * 100) + "%";

            if (angle >= targetPercent) {
              clearInterval(timer);
            }
            angle += 7;
          }, 30);
        });
        observer.unobserve(entry.target);
      }
    });
  }
  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.5,
  });
  const elements = document.querySelectorAll('.svg-wrapper');
  elements.forEach((element) => {
    observer.observe(element);
  });
});
